export default __webpack_public_path__ + "static/media/zero.2f2c0a36.svg";